import { makeAutoObservable } from 'mobx';
import { IAsset } from '../models/asset';
import { RootStore } from './rootStore';
import { useToast } from '@chakra-ui/react';
import admin from '../api/admin';
import { ISite } from '../models/site';
import { CreateAssetRequest, GetAssetsResponse, GetSitesResponse } from '../models/admin-api/dto';

export class AssetStore {
  siteAssets: IAsset[] = [];
  sites: ISite[] = [];

  isUploading = false;

  root: RootStore;
  toast = useToast();

  constructor(root: RootStore) {
    this.root = root;
    makeAutoObservable(this);
  }

  //Get All Sites for the Current User
  async getSites() {
    await admin.Sites.GetSites(1)
      .then((response: GetSitesResponse) => {
        if (response && response.result !== undefined) {
          this.sites = response.result;
        } else {
          this.toast({
            title: 'Error',
            description: 'Error retrieving sites! - Please try again',
            status: 'error',
            duration: 2000,
            isClosable: true,
          });

          console.log('Error listing Site Error:', response.message);
          this.sites = [];
        }
      })
      .catch((error: any) => {
        this.toast({
          title: 'Error',
          description: 'Error retrieving projects! - Please try again',
          status: 'error',
          duration: 2000,
          isClosable: true,
        });

        console.log('Error listing Project Error:', error);
      });
  }

    //Get All Assets for a Given Site
  async getAssetsBySiteId(siteId:number) {
      await admin.Assets.GetAssets(siteId)
        .then((response: GetAssetsResponse) => {
          if (response && response.result !== undefined) {
            this.siteAssets = response.result;
          } else {
            this.toast({
              title: 'Error',
              description: 'Error retrieving sites! - Please try again',
              status: 'error',
              duration: 2000,
              isClosable: true,
            });
  
            console.log('Error listing Site Error:');
            this.sites = [];
          }
        })
        .catch((error: any) => {
          this.toast({
            title: 'Error',
            description: 'Error retrieving projects! - Please try again',
            status: 'error',
            duration: 2000,
            isClosable: true,
          });
  
          console.log('Error listing Project Error:', error);
        });
    }


    //Creates new Organisation
   async createAsset(assetObj: IAsset) {
      var assetRequest = {
          asset: assetObj
      } as CreateAssetRequest;
  
      var response = await admin.Assets.CreateAsset(assetRequest);
      return response;
    };
 
}
